export const AdminPermissions = {
  CanViewOverview: "CanViewOverview",
  CanManageSubscriptions: "CanManageSubscriptions",
  CanManagePlans: "CanManagePlans",
  CanManagePlanCoupons: "CanManagePlanCoupons",
  CanManagePlatformWhatsApp: "CanManagePlatformWhatsApp",
  CanManagePlatformNotices: "CanManagePlatformNotices",
  CanViewCommercialPerformance: "CanViewCommercialPerformance",
  CanViewFinancialMetrics: "CanViewFinancialMetrics",
  CanViewRestaurantFinancialHealth: "CanViewRestaurantFinancialHealth",
  CanQueryMercadoPago: "CanQueryMercadoPago",
  CanManageGrowthInvestments: "CanManageGrowthInvestments",
  CanManageTutorials: "CanManageTutorials",
  CanViewServerRuntime: "CanViewServerRuntime",
  CanManageServerLogs: "CanManageServerLogs",
  CanViewLandingLeads: "CanViewLandingLeads",
  CanManageResellers: "CanManageResellers",
} as const

export type AdminPermissionsType = (typeof AdminPermissions)[keyof typeof AdminPermissions]
